import gql from "graphql-tag";
const GET_SESSION_DATA_BY_KEY = gql`
	query ($key: String!) {
		value: sessionDataValueByKey(key: $key)
	}
`;
export {
  GET_SESSION_DATA_BY_KEY
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2Vzc2lvbi1zdG9yZS5qcyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dyYXBocWwvc2Vzc2lvbi1zdG9yZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgZ3FsIGZyb20gXCJncmFwaHFsLXRhZ1wiO1xuXG5leHBvcnQgY29uc3QgR0VUX1NFU1NJT05fREFUQV9CWV9LRVkgPSBncWxgXG5cdHF1ZXJ5ICgka2V5OiBTdHJpbmchKSB7XG5cdFx0dmFsdWU6IHNlc3Npb25EYXRhVmFsdWVCeUtleShrZXk6ICRrZXkpXG5cdH1cbmA7Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFFTyxNQUFNLDBCQUEwQjtBQUFBO0FBQUE7QUFBQTtBQUFBOyJ9
